import React, { Component } from "react";
import MakeKey from "../../commons/services/MakeKey";

import axios from "axios";
import CS from "../../commons/services/Common";
import MS from "../../commons/services/Moment";
import PS from "../PlantList/MonitoringApiService";
import PowerSystem from "./components/PowerSystem";
import SystemInfo from "./components/SystemInfo";
import PowerPlantInfo from "./components/PowerPlantInfo";
import EnergyMonitoring from "./components/EnergyMonitoring";
import { ContentContainer, GridContainer, ProjectTitle } from "./common/style";
import { CarrierDataRes } from "../PlantList/Power/dto/CarrierDataRes";
import _ from "lodash";
import { withTranslation } from "react-i18next";

class EmsMainNew extends Component {
  constructor(props) {
    super(props);
    const { projectId } = props.match.params;
    const project = this.props.location?.state?.project || {};

    this.state = {
      projectId: projectId,
      project: project,
      plantList: [],
      inverterList: [],
      deviceList: [],
      deviceData: [],
      batteryList: [],
      inverterKey: [],
      deviceKey: [],
      batteryKey: [],
      systemInfo: {
        date: "24-01-01",
        time: "PM 13:00",
        solar: {
          installationCapacity: 0,
          count: 0,
          todayPower: 0,
        },
        battery: {
          capacity: 0,
          chargeVoltage: 0,
          chargeAmpere: 0,
          dischargeVoltage: 0,
          dischargeAmpere: 0,
          count: 0,
        },
        device: {
          capacity: 0,
          count: 0,
        }
      },
      emsInvSum: [],
      emsInvData: [],
      emsCarrierSum: [],
      emsCarrierData: [],
      emsBatterySum: [],
      emsBatteryData: [],
    }
  }

  async componentDidMount() {

    await Promise.all([
      this.getProjectInfo(),
      this.getPlant(),
      this.getDevice(),
      this.getBattery(),
    ]);
    await this.getEmsData();
  }

  async getProjectInfo() {
    const { projectId } = this.state;
    try {
      const res = await axios.get(`/cst/api/project/id/${projectId}`);

      if (res.status === 200) {
        this.setState({ project: res.data });
      } else {
        this.setState({ project: {} });
      }
    } catch (error) {
      console.error("Error fetching project info:", error);
      this.setState({ project: {} });
    }
  }

  // 보유하고 있는 발전소 정보 가져오기
  async getPlant() {
    const { projectId } = this.state;
    try {
      const response = await axios.get(
        `/cst/api/constructor-plant/project/${projectId}`
      );
  
      const resData = response.data.data;
      
      const installationCapacity = CS.sumValuesAtPath(resData, 'installationCapacity');

      this.setState(
        { 
          plantList: resData, 
          systemInfo: { ...this.state.systemInfo, solar: { installationCapacity, count: resData.length } } 
        }
      );
      await this.getInverter(resData);
    } catch (error) {
      console.error("Error getting plant data:", error); 
    }
  }

  // 발전소에 설치된 인버터 정보 가져오기
  async getInverter(plantList) {
    try {
        const inverterResponses = await Promise.all(
            plantList.map(({ id: plantId }) => 
                axios.get(`/cst/api/constructor-plant/equipment/${plantId}`)
            )
        );

        const inverterList = inverterResponses
            .map(response => response.data)
            .flat();

        const {
          todayPower
        } = await this.getTodayPower(inverterList);
        
        this.setState({
            inverterList,
            inverterKey: inverterList.map((inverter) => inverter.inverterNo),
            systemInfo: { 
              ...this.state.systemInfo, 
              solar: { 
                ...this.state.systemInfo.solar,
                todayPower
              } 
            }
        });
    } catch (error) {
        console.error("Error getting inverter data:", error);
    }
  }

  async getTodayPower(inverterList) {
    const inverterSerialNos = inverterList.map(inv => inv?.inverterNo);
    const accumulationParam = {
      inverterSerialNos: inverterList.map(inv => inv?.inverterNo),
      fromDate: MS.format(new Date(), "YYYY-MM-DD HH:00:00"),
      toDate: MS.format(new Date(), "YYYY-MM-DD HH:mm:ss"),
    }
    try {
      const currentHourPowerList = await PS.getAccumulationPowerList(accumulationParam);
      let currentHourPower = 0;
      currentHourPowerList.forEach((v) => {
        currentHourPower += v.lastPower - v.firstPower;
      });
      
      const todayPowerParam = {
        isPeriod: false,
        inverterSerialNos: inverterSerialNos,
        dateType: "ymd",
        date: MS.current("YYYY-MM-DD"),
        groupCols: ["ymd"],
      }
      const todayPower = (await PS.getTodayPower(todayPowerParam)) + currentHourPower;
      
      return {
        todayPower
      }
    } catch (error) {
      console.error(error);
    }
  }

  // 보유하고 있는 전력기기 정보 가져오기
  async getDevice() {
    const { projectId } = this.state;
    const { t } = this.props;
    const data = {
      projectId: projectId,
    };

    try {
      const res = await axios.post("/cst/api/device/search", data);
      const resData = res.data.data;

      const capacity = CS.sumValuesAtPath(resData, 'pwConsumption');

      const uniqueDeviceKey = this.makeDeviceUniqueKey(resData);

      const deviceData = (await this.getDeviceData(resData)) || [];

      this.setState({ 
        deviceKey: uniqueDeviceKey, 
        deviceList: resData, 
        deviceData: deviceData,
        systemInfo: { 
          ...this.state.systemInfo, 
          device: { capacity, count: resData.length }
        } 
      });
    } catch (error) {
      console.error(t('key524'), error); // 전력기기 정보 불러오기 실패
    }
  }

  async getDeviceData(deviceList) { 
    const { t } = this.props;
    try {
      // new unique carrier key
      const uniqueCarrierList = []; // { key: `${siteNo}-${rtuNo}`, siteNo, rtuNo, deviceNos: [] }
      const uniqueCarrierKeyList = [];
      // deviceList에서 siteNo, rtuNo가 중복되지 않는 데이터만 추출 (deviceNos: 해당 siteNo, rtuNo에 해당하는 deviceNo들)
      deviceList.forEach((device) => {
        const { siteNo, deviceNo, rtuNo } = device;
        const key = `${siteNo}-${rtuNo}`;
        const findIdx = uniqueCarrierList.findIndex((carrier) => carrier.key === key);
        const carrierKey = MakeKey.carrier({ siteNo, rtuNo, deviceNo });
        uniqueCarrierKeyList.push(carrierKey);
        if (findIdx === -1) {
          uniqueCarrierList.push({
            key,
            siteNo,
            rtuId: rtuNo,
            deviceNos: [deviceNo],
          });
        } else {
          uniqueCarrierList[findIdx].deviceNos.push(deviceNo);
        }
      });

      // carrier data 불러오기
      const carrierData = [];
      if (!uniqueCarrierKeyList || uniqueCarrierKeyList.length === 0) return;
      const res = await PS.getCarriersData(_.uniq(uniqueCarrierKeyList));
      res.forEach((data) => {
        const resEntity = new CarrierDataRes(data);
        carrierData.push(resEntity.toObject());
      });

      // for (let i = 0; i < uniqueCarrierList.length; i++) {
      //   // uniqueCarrierList에 해당하는 데이터 불러오기
      //   const res = await PS.getCarriersData(uniqueCarrierList[i]);
      
      //   if (res && res.length > 0) {
      //     res.forEach((data) => {
      //       const resEntity = new CarrierDataRes(data);
      //       carrierData.push(resEntity.toObject());
      //     })
      //   }
      //   // 불러온 데이터를 carrierData에 추가
      //   // carrierData = carrierData.concat(res);
      // }
      
      // carrierData 업데이트
      return carrierData;

    } catch (error) {
      console.error(t("key525"), error); // 캐리어 데이터 불러오기 실패
    }
  }

  // 보유하고 있는 배터리 정보 가져오기
  async getBattery() {
    const { projectId } = this.state;
    const { t } = this.props;
    try {
      const response = await axios.get(
        `/cst/api/battery/${projectId}`
      )
      const resData = response.data;
      
      
      const capacity = CS.sumValuesAtPath(resData, 'capacity');
      const batteryVoltageAndAmpere = await this.getBatteryData(resData);
      
      this.setState({ 
        batteryList: resData, 
        systemInfo: { 
          ...this.state.systemInfo, 
          battery: { capacity, count: resData.length, ...batteryVoltageAndAmpere }
        } 
      }, this.makeBatteryUniqueKey(resData));

    } catch (error) {
      console.error(t('key523'), error); // 배터리 정보 불러오기 실패
    }
  }

  async getBatteryData(batteryList) {
    const uniqueBatteryList = [];
    const uniqueBatteryKeyList = [];

    batteryList.forEach(battery => {
      const { siteNo, rtuNo, deviceNo } = battery;
      const key = `${siteNo}-${rtuNo}`;
      const findInx = uniqueBatteryList.findIndex(b => b.key === key);
      if (findInx === -1) {
        uniqueBatteryList.push({
          key,
          siteNo,
          rtuNo,
          deviceNos: [deviceNo]
        });
        uniqueBatteryKeyList.push(MakeKey.battery({ siteNo, rtuNo, deviceNo }));
      } else {
        uniqueBatteryList[findInx].deviceNos.push(deviceNo);
      }
    });

    let batteryData = [];
    try {
      // for (let i = 0; i < uniqueBatteryList.length; i++) {
      //   const res = await PS.getBatteryDetail({
      //     siteNo: uniqueBatteryList[i].siteNo,
      //     rtuId: uniqueBatteryList[i].rtuNo,
      //     deviceNos: uniqueBatteryList[i].deviceNos
      //   })
        
      //   batteryData = [...batteryData, ...res];
      // }
      if (uniqueBatteryKeyList && uniqueBatteryKeyList.length !== 0) {
        batteryData = await PS.getBatteryDetail(uniqueBatteryKeyList);
      }
    } catch (error) {
      console.error("Error getting battery data:", error);
    }
    const chargeVoltage = CS.sumValuesAtPath(batteryData, 'ed1ChargeVoltage');
    const chargeAmpere = CS.sumValuesAtPath(batteryData, 'ed1ChargeAmprere');
    const dischargeVoltage = CS.sumValuesAtPath(batteryData, 'ed2DischargeVoltage');
    const dischargeAmpere = CS.sumValuesAtPath(batteryData, 'ed2DischargeAmprere');
    const chargeWattage = CS.sumValuesAtPath(batteryData, 'ed1ChargeWattage');
    const dischargeWattage = CS.sumValuesAtPath(batteryData, 'ed2DischargeWattage');
    
    return {
      chargeVoltage,
      chargeAmpere,
      chargeWattage,
      dischargeVoltage,
      dischargeAmpere,
      dischargeWattage,
    }
  }

  // EMS 데이터 가져오기
  async getEmsData() {
    const { inverterKey, deviceKey, batteryKey } = this.state;
    const date = MS.current('YYYY-MM-DD');

    const invParams = { inverterSerialNos: inverterKey, date };
    const carrierParams = { carrierSerialNos: deviceKey, date };
    const batteryParams = { batterySerialNos: batteryKey, date };

    try {
        // 모든 API 요청을 병렬로 실행
        // const [
        //     emsInvSum = [], 
        //     emsInvData = [], 
        //     emsCarrierSum = [], 
        //     emsCarrierData =[], 
        //     emsBatterySum = [], 
        //     emsBatteryData = []
        // ] = await Promise.all([
        //     PS.getEmsInvSum(invParams),
        //     PS.getEmsInvData(invParams),
        //     PS.getEmsCarrierSum(carrierParams),
        //     PS.getEmsCarrierData(carrierParams),
        //     PS.getEmsBatterySum(batteryParams),
        //     PS.getEmsBatteryData(batteryParams)
        // ]);

        const [
          emsInvSum = [], 
          emsInvData = [], 
          emsCarrierSum = [], 
          emsCarrierData =[], 
          emsBatterySum = [], 
          emsBatteryData = []
        ] = await Promise.all([
          Array.isArray(inverterKey) && inverterKey.length > 0 ? PS.getEmsInvSum(invParams) : Promise.resolve([]),
          Array.isArray(inverterKey) && inverterKey.length > 0 ? PS.getEmsInvData(invParams) : Promise.resolve([]),
          Array.isArray(deviceKey) && deviceKey.length > 0 ? PS.getEmsCarrierSum(carrierParams) : Promise.resolve([]),
          Array.isArray(deviceKey) && deviceKey.length > 0 ? PS.getEmsCarrierData(carrierParams) : Promise.resolve([]),
          Array.isArray(batteryKey) && batteryKey.length > 0 ? PS.getEmsBatterySum(batteryParams) : Promise.resolve([]),
          Array.isArray(batteryKey) && batteryKey.length > 0 ? PS.getEmsBatteryData(batteryParams) : Promise.resolve([])
        ]);
        
        // 한 번에 state 업데이트
        this.setState({
            emsInvSum,
            emsInvData,
            emsCarrierSum,
            emsCarrierData,
            emsBatterySum,
            emsBatteryData,
        });
    } catch (error) {
        console.error("Error getting ems data:", error);
    }
  }

  
  // helper Functions
  makeDeviceUniqueKey(deviceList) {
    const uniqueCarrierList = []; // { key: `${siteNo}-${rtuNo}`, siteNo, rtuNo, deviceNos: [] }

    // deviceList에서 siteNo, rtuNo가 중복되지 않는 데이터만 추출 (deviceNos: 해당 siteNo, rtuNo에 해당하는 deviceNo들)
    deviceList.forEach((device) => {
      const { siteNo, deviceNo, rtuNo } = device;
      const key = `${siteNo}-${rtuNo}-${deviceNo}`;
      const findIdx = uniqueCarrierList.findIndex((carrier) => carrier.key === key);
      if (findIdx === -1) {
        uniqueCarrierList.push({
          key,
          siteNo,
          rtuId: rtuNo,
          deviceNo: deviceNo,
        });
      }
    });

    const uniqueCarrierKeyList = [];
    uniqueCarrierList.forEach((carrier) => {
      const { siteNo, rtuId, deviceNo } = carrier;
      const key = MakeKey.carrier({ siteNo, rtuNo: rtuId, deviceNo });
      uniqueCarrierKeyList.push(key);
    });
    return uniqueCarrierKeyList;
  }

  makeBatteryUniqueKey(batteryList) {
    const uniqueBatteryList = []; // { key: `${siteNo}-${rtuNo}`, siteNo, rtuNo, deviceNos: [] }

    // deviceList에서 siteNo, rtuNo가 중복되지 않는 데이터만 추출 (deviceNos: 해당 siteNo, rtuNo에 해당하는 deviceNo들)
    batteryList.forEach((battery) => {
      const { siteNo, deviceNo, rtuNo } = battery;
      const key = `${siteNo}-${rtuNo}-${deviceNo}`;
      const findIdx = uniqueBatteryList.findIndex((battery) => battery.key === key);
      if (findIdx === -1) {
        uniqueBatteryList.push({
          key,
          siteNo,
          rtuId: rtuNo,
          deviceNo: deviceNo,
        });
      }
    });

    const uniqueBatteryKeyList = [];
    uniqueBatteryList.forEach((battery) => {
      const { siteNo, rtuId, deviceNo } = battery;
      const key = MakeKey.battery({ siteNo, rtuNo: rtuId, kind: 70, deviceNo });
      uniqueBatteryKeyList.push(key);
    });
    this.setState({ batteryKey: uniqueBatteryKeyList });
  }

  
  render() {
    const { 
      projectId, 
      project, 
      plantList, 
      inverterList,
      deviceList, 
      deviceData,
      batteryList, 
      systemInfo,
      emsInvSum,
      emsInvData,
      emsCarrierSum,
      emsCarrierData,
      emsBatterySum,
      emsBatteryData,
      deviceKey,
      batteryKey
    } = this.state;
    const { t } = this.props;
    const { name = "-" } = project;
    return (
      <>
        <ProjectTitle>
          <div>
            {name}
          </div>
        </ProjectTitle>
        <ContentContainer>
          <GridContainer girdFr={"1fr 276px"}>
            <PowerSystem
              projectId={projectId} 
              plantList={plantList}
              deviceList={deviceList}
              batteryList={batteryList}
              inverterList={inverterList}
              emsInvSum={emsInvSum}
              emsInvData={emsInvData}
              emsCarrierSum={emsCarrierSum}
              emsCarrierData={emsCarrierData}
              emsBatteryData={emsBatteryData}
              emsBatterySum={emsBatterySum}
              batteryCapacity={systemInfo.battery.capacity}
              batteryChargeVoltage={systemInfo.battery.chargeVoltage}
              batteryChargeAmpere={systemInfo.battery.chargeAmpere}
              batteryDischargeVoltage={systemInfo.battery.dischargeVoltage}
              batteryDischargeAmpere={systemInfo.battery.dischargeAmpere}
              todayPower={systemInfo.solar.todayPower}
            />
            <SystemInfo systemInfo={systemInfo}/>
          </GridContainer>
          <GridContainer girdFr={"210px 210px 1fr"}>
            <PowerPlantInfo
              plantList={plantList}
              emsInvSum={emsInvSum}
              emsInvData={emsInvData}
              emsCarrierSum={emsCarrierSum}
              emsCarrierData={emsCarrierData}
              emsBatterySum={emsBatterySum}
              emsBatteryData={emsBatteryData}
              batteryCapacity={systemInfo.battery.capacity}
              battery={systemInfo.battery}
              deviceData={deviceData}
            />
          </GridContainer>
          <GridContainer girdFr={"1fr"}>
            <EnergyMonitoring 
              inverterList={inverterList}
              batteryKey={batteryKey}
              deviceKey={deviceKey}
            />
          </GridContainer>
        </ContentContainer>
      </>
    )
  }
}


export default withTranslation()(EmsMainNew);
